module.exports = __webpack_public_path__ + "img/NimbusDrive_Logo.e7c7e0cb.png";